import './credit-card-form.scss';
import React from 'react';
import { Controls } from 'shared/helper/form';
import { BANK_TRANSFER } from 'researcher/domain/transaction/payment-method';
var Text = Controls.Text;
var styles = {
  wrapper: 'mb-3'
};
export var defaultValues = {
  number: ''
};
var PurchaseOrderForm = function PurchaseOrderForm(_ref, isChinaUser) {
  var paymentMethodId = _ref.paymentMethodId;
  if (paymentMethodId !== BANK_TRANSFER || isChinaUser) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "row credit-card-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Text, {
    label: "Purchase order number",
    name: "purchaseOrder[number]",
    styles: styles
  })));
};
export default PurchaseOrderForm;